var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReporting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.464 40.258V7.742H30.49v8.145h8.145v24.37H9.465zM32.475 9.146l4.757 4.757h-4.757V9.146zm8.135 5.75a.976.976 0 0 0-.282-.702l-8.144-8.145a.987.987 0 0 0-.7-.282v-.01H7.48v36.485h33.14V14.896h-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 35.142h20.7v-1.984H13.7zM13.7 28.724h20.7V26.74H13.7zM13.7 22.306h20.7v-1.984H13.7zM13.699 15.887h11.257v-1.984H13.699z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.c25670d4de4458c9126e97ae2dc472ff.svg";
export { ForwardRef as ReactComponent };